export default "__VITE_ASSET__DzWFzaGT__"